const getCompanyRootDocumentBase = (rootDocument) => {
  return String(rootDocument || "").replace(/[^A-Z\d]/g, "").slice(0, 8);
};

const companyRootDocument = getCompanyRootDocumentBase(window.companyRootDocument);

function formatCNPJ(value) {
  const digits = String(value || "").replace(/[^A-Z\d]/g, "").slice(0, 14);

  if (digits.length <= 2) return digits;
  if (digits.length <= 5) return digits.replace(/^([A-Z\d]{2})([A-Z\d]+)/, "$1.$2");
  if (digits.length <= 8) return digits.replace(/^([A-Z\d]{2})([A-Z\d]{3})([A-Z\d]+)/, "$1.$2.$3");
  if (digits.length <= 12) return digits.replace(/^([A-Z\d]{2})([A-Z\d]{3})([A-Z\d]{3})([A-Z\d]+)/, "$1.$2.$3/$4");

  return digits.replace(/^([A-Z\d]{2})([A-Z\d]{3})([A-Z\d]{3})([A-Z\d]{4})([A-Z\d]{2})$/, "$1.$2.$3/$4-$5");
}

function MaskCNPJ(input) {
  const mensagemErro = document.createElement('div');
  mensagemErro.textContent = 'CNPJ Inválido';
  mensagemErro.style.cssText = `
        color: #dc3545;
        font-size: 12px;
        margin-left: 8px;
        margin-top: 4px;
        display: none;
    `;

  input.parentNode.insertBefore(mensagemErro, input.nextSibling);

  input.addEventListener('input', function (e) {
    const valorOriginal = String(e.target.value);
    let valor = valorOriginal.replace(/[^A-Z\d]/gi, '').toUpperCase();
    
    const cnpjInvalido = !/^([A-Z\d]{0,12})([\d]{0,2})$/i.test(valor);
    
    if (cnpjInvalido) {
      mensagemErro.style.display = 'block';
      setTimeout(() => {
        mensagemErro.style.display = 'none';
      }, 3000);
    }

    valor = valor.substring(0, 12) + valor.substring(12).replace(/[A-Z]/i, '');

    valor = valor.substring(0, 14);
    valor = valor.replace(/^([A-Z\d]{2})([A-Z\d])/, '$1.$2');
    valor = valor.replace(/^([A-Z\d]{2})\.([A-Z\d]{3})([A-Z\d])/, '$1.$2.$3');
    valor = valor.replace(/\.([A-Z\d]{3})([A-Z\d])/, '.$1/$2');
    valor = valor.replace(/([A-Z\d]{4})(\d)/, '$1-$2');

    e.target.value = valor;
  });
}

function showTemporaryError(
  input,
  message,
  duration = 2000,
  id = "field-temp-error",
) {
  if (!input) return;
  let msg = document.getElementById(id);
  if (!msg) {
    msg = document.createElement("div");
    msg.id = id;
    msg.style.cssText = `
            color: #dc3545;
            font-size: 12px;
            margin-left: 8px;
            margin-top: 4px;
            display: none;
        `;
    input.parentNode.insertBefore(msg, input.nextSibling);
  }
  msg.textContent = message;
  msg.style.display = "block";
  clearTimeout(msg._hideTimeout);
  msg._hideTimeout = setTimeout(() => {
    msg.style.display = "none";
  }, duration);
}

async function getCompanyusers(rootDocument) {
  const token = await login();
  const url = `${baseUrl}/shopify-order-connector/v1/shopify-order-connector/organizations/membersByCompany?organizationRootDocument=${rootDocument}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Erro ao buscar dados de organizações.");
  }
  
  return response.json();
}

async function loadCompanyUsersData() {
  const companyUsersContainer = document.querySelector("#users-container");
  companyUsersContainer.innerHTML = ``;

  showMyAccountSpinner(companyUsersContainer);

  try {
    const companyUsers = await getCompanyusers(companyRootDocument);

    if (companyUsers.length === 0 || !companyUsers) {
      companyUsersContainer.innerHTML = `
        <div class="dados users-dados">
          <p>Você ainda não tem outros usuários cadastrados.</p>
        </div>
        `;
      removeMyAccountSpinner(companyUsersContainer);
      return;
    }

    renderCompanyUsersData(companyUsers, companyUsersContainer);
  } catch (error) {
    companyUsersContainer.innerHTML = `
        <div class="dados users-dados">
          <span>Ocorreu um erro ao buscar ao buscar os usuários da empresa.</span>
          <p>${error.message}</p>
        </div>
      `;
  } finally {
    removeMyAccountSpinner(companyUsersContainer);
  }
}

function renderCompanyUsersData(data, container) {

  if (!data || data.length === 0) {
    container.innerHTML = `
      <div class="dados users-dados">
        <p>Nenhuma filial encontrada para esta empresa.</p>
      </div>
    `;
    return;
  }

  container.innerHTML = ` `;

  const companyIconTemplate = document.getElementById('company-icon');

  data.forEach((location) => {
    const locationDiv = document.createElement("div");
    locationDiv.className = "dados users-dados";

    const locationInfo = document.createElement("div");
    locationInfo.className = "users-info";

    if (companyIconTemplate) {
      const companyIcon = companyIconTemplate.cloneNode(true);
      companyIcon.removeAttribute('id');
      companyIcon.style.display = 'block';
      locationInfo.appendChild(companyIcon);
    }

    const locationName = document.createElement("p");
    locationName.textContent = formatCNPJ(location.cnpj);
    locationInfo.appendChild(locationName);
    
    const locationAddress = document.createElement("p");
    locationAddress.textContent = location.address;
    locationInfo.appendChild(locationAddress);

    const divider = document.createElement("hr");
    divider.className = "divider";
    locationInfo.appendChild(divider);

    if (location.members && location.members.length > 0) {
      location.members.forEach((member) => {
        if (member.userActive?.value === 'false' || member.isTeleSales?.value === 'true') return;

        const memberDiv = document.createElement("div");
        memberDiv.className = "member-info";

        const userName = document.createElement("p");
        userName.className = "user-name";
        userName.textContent = member.displayName;
        memberDiv.appendChild(userName);

        const userEmail = document.createElement("span");
        userEmail.className = "user-email";
        userEmail.textContent = member.email;
        memberDiv.appendChild(userEmail);
        locationInfo.appendChild(memberDiv);
      });      
    }

    locationDiv.appendChild(locationInfo);
    container.appendChild(locationDiv);


  });

}